/**
 * MenuCollapseIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const MenuCollapseIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M3.2 6a.8.8 0 1 1 1.6 0v12a.8.8 0 0 1-1.6 0zm10.367.434a.8.8 0 0 0-1.132 0l-4.977 4.977a.8.8 0 0 0-.258.572V12a.8.8 0 0 0 .234.566l5.001 5a.8.8 0 1 0 1.132-1.132L9.93 12.8H20a.8.8 0 0 0 0-1.6H9.932l3.635-3.634a.8.8 0 0 0 0-1.132" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const MenuCollapseIcon = makeIcon('MenuCollapseIcon', MenuCollapseIconSvg)
